import { render, staticRenderFns } from "./AdaTableClient.vue?vue&type=template&id=41f896be&scoped=true"
import script from "./AdaTableClient.vue?vue&type=script&lang=js"
export * from "./AdaTableClient.vue?vue&type=script&lang=js"
import style0 from "./AdaTableClient.vue?vue&type=style&index=0&id=41f896be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f896be",
  null
  
)

export default component.exports